import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import RightArrowIcon from '../../i/icons/right-arrow.svg';

export const SignUpForm = ({ title, buttonTitle }) => {
	return (
		<div className="sign_up_wrap">
			<h2 className="signup_title">
				{ReactHtmlParser(title)}
			</h2>
			<form className="signup_form">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod">
						<label htmlFor="signup" />
					</dt>
					<dd className="form_field_wrap form_v1_mod">
						<input
							className="form_field v2_mod default_mod"
							type="email"
							id="signup"
							placeholder="Type your email"
						/>
					</dd>
				</dl>
				<button className="signup_btn">
					{buttonTitle}
					<div className="signup_btn_icon">
						<RightArrowIcon className="icon icon-right-arrow size_mod" />
					</div>
				</button>
			</form>
		</div>
	);
}
export default SignUpForm;